module.exports = __webpack_public_path__ + "img/about.02d7c212.svg";